import React, { Component } from 'react';
import Translator from '../../core/i18n';
import { Common } from '../../core/common';
import Moment from 'moment';
import { IMessage } from '../../models/pages/messages';
import { SecureImage } from '../../components/core/secureImage';
import { MessagesService } from '../../api/message-services';

import * as Icons from 'react-icons/md';
import imgPdf from '../../static/images/coloricons/pdf.svg';
import imgWord from '../../static/images/coloricons/word.svg';
import imgExcel from '../../static/images/coloricons/excel.svg';
import imgPowerpoint from '../../static/images/coloricons/powerpoint.svg';
import imgVideo from '../../static/images/coloricons/video.svg';
import imgSound from '../../static/images/coloricons/sound.svg';
import imgImage from '../../static/images/coloricons/image.svg';
import { SecureLink } from '../../components/core/secureLink';

import { Log } from 'ng2-logger';
import { MessageDeletionType } from '../../models/enums/MessageDeletionType';
import { Confirm, Notification } from '../../components/notification/main';
import 'react-quill/dist/quill.snow.css';

const _logger = Log.create('Message Page');

const T = Translator.create();
let _common: Common;
const messagesService = new MessagesService();

export class ChatPanelItem extends Component<IMessage, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }
    formatDate() {
        const today = Moment().startOf('day');
        const messageDate = Moment(this.props.date);
        if (messageDate >= today) {
            return messageDate.format('H:mm');
        } else {
            return messageDate.format('D MMMM Y H:mm');
        }
    }

    deleteMessage = (messageId: string, deleteType: number) => {
        Confirm.setConfirm(
            'deleteMessage',
            () => this.deleteMessageConfirmed(messageId, deleteType), null, null, { warningText: T.t('r_gen_delete_message_warning'), userImagePath: this.props.imageUrl, nameSurname: this.props.senderName, date: Moment(this.props.date).format('DD.MM.YYYY HH:mm'), message: this.props.message, fileName: this.props.fileName });
    };

   deleteMessageConfirmed = (messageId: string, deleteType: number) => {
        Notification.setNotification('success', T.t('r_message_deleted'), 'topRight');

        messagesService.RequestDeleteMessageAsync(messageId, deleteType).then(data => {
                this.props.refreshPage();
        })
    }


    onImageClick = (e: any) => {
        window.open(e.currentTarget.src, '_tab');
    };

    returnFileIconByExt = (ext: any) => {
        let fileIcon = null;

        if (ext === 'pdf' || ext === 'ppdf') {
            fileIcon = <img alt='imgPdf' src={imgPdf} />;
        } else if (/docx?/gi.test(ext)) {
            fileIcon = <img alt='imgWord' src={imgWord} />;
        } else if (/xlsx?/gi.test(ext)) {
            fileIcon = <img alt='imgExcel' src={imgExcel} />;
        } else if (/pptx?/gi.test(ext)) {
            fileIcon = <img alt='imgPowerpoint' src={imgPowerpoint} />;
        } else if (/mp4/gi.test(ext)) {
            fileIcon = <img alt='imgVideo' src={imgVideo} />;
        } else if (/mp3/gi.test(ext)) {
            fileIcon = <img alt='imgSound' src={imgSound} />;
        } else if (/jpe?g|png|gif/gi.test(ext)) {
            fileIcon = <img alt='imgImage' src={imgImage} />;
        } else {
            fileIcon = <Icons.MdInsertDriveFile size="22" />;
        }
        return fileIcon;
    }

    getFileIcon = (filePath: any) => {
        let fileIcon = null;
        if (filePath && filePath.lastIndexOf('.') > 0) {
            const ext = filePath.substr(filePath.lastIndexOf('.') + 1);
            fileIcon = this.returnFileIconByExt(ext)
        } else {
            fileIcon = <Icons.MdInsertDriveFile size="22" />;
        }
        return fileIcon;
    };

    isImage = (path: string) => {
        return /\.(jpe?g|png|gif)$/gi.test(path);
    };

    humanFileSize = (bytes: number, si: boolean) => {
        const thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        const units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    };

    renderAttachment = () => {
        if (!this.props.filePath || this.props.filePath.length === 0) {
            return null;
        }

        if (this.isImage(this.props.fileName)) {
            return (
                <div
                    className="mt-3"
                    style={{
                        padding: '3px',
                        backgroundColor: '#f5f5f5',
                        border: '1px solid #eee',
                        boxShadow: '3px 3px 5px 1px rgba(0, 0, 0, .2)'
                    }}
                >
                    <SecureImage
                        style={{ maxWidth: '100%', maxHeight: '250px' }}
                        imageUrl={this.props.filePath}
                        onClick={this.onImageClick}
                    />
                </div>
            );
        }

        const fileIcon = this.getFileIcon(this.props.fileName);
        return (
            <div
                className="mt-3"
                style={{
                    padding: '3px',
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #eee',
                    borderRadius: '5px',
                    boxShadow: '3px 3px 5px 1px rgba(0, 0, 0, .2)'
                }}
                data-path={this.props.filePath}
            >
                {fileIcon} <SecureLink src={this.props.filePath} target="tab" download={false} fileName={this.props.fileName} />
                <div className="mt-1">
                    {this.humanFileSize(this.props.fileSize, false)} -
                    <SecureLink src={this.props.filePath} download={true} fileName={T.t('r_download')} />
                </div>
            </div>
        );
    };

    improveV3Message = (message: any) => {
        const plaintext = message.replace(/<blockquote>.*?<\/blockquote>/, '');
        return plaintext
    }

     removeInlineStyles = (htmlString: string) =>  {
        const parser = new DOMParser();

        const doc = parser.parseFromString(htmlString, 'text/html');

        const elementsWithStyle = doc.querySelectorAll('[style]');
        elementsWithStyle.forEach(element => {
            element.removeAttribute('style');
        });

        return doc.body.innerHTML;
    }

    getMessageBody = () => {
        if (this.props.message) {
            let plainMessage = this.improveV3Message(this.props.message);
           // const doc = new DOMParser().parseFromString(plainMessage, 'text/html');
            plainMessage = this.removeInlineStyles(plainMessage);
            const currentMessageBody = plainMessage ?? "";
            return plainMessage;
        }
        return '';
    };

    public render() {
        return (
            <div className={'message-bar d-flex align-items-start gap-1 m-p-0 ' + (this.props.isOwnMessage ? 'align-self-end flex-row-reverse' : '')} style={{ margin: '8px 0px 8px 0', width: 'fit-content' }}>
                <div className="userinfo media align-items-center">
                    <SecureImage class={'chat_avatar' + (this.props.isOwnMessage ? 'd-none' : '')} style={{ maxWidth: '50px' }} imageUrl={this.props.imageUrl} imgType="avatar" />

                </div>
                <div className={'message-content message-right-menu ' + (this.props.isOwnMessage ? 'own-message' : 'other-message')} style={{ float: this.props.isOwnMessage ? 'right' : 'left', marginRight: this.props.isOwnMessage ? '8px' : '' }}>
                    <div>
                        <div className="media-body ml-1">
                            <span className={'sender_name'}>{this.props.senderName}</span>
                            <i className="send_date">{this.formatDate()}</i>
                        </div>
                        <p>
                            {this.props.message && this.props.message.length > 0 ? (
                                <div style={{minHeight: "auto", maxHeight: "unset", padding: "0px", overflow: "hidden"}} className={ (!_common.isArabic(this.getMessageBody()) ? 'left-text mt-2 mx-1 ql-editor' : 'mt-2 mx-1 ql-editor')} dangerouslySetInnerHTML={{ __html: this.getMessageBody() }} />
                            ) : null}
                            {this.renderAttachment()}

                        </p>
                    </div>
                    <div className={' dropdown ' + (this.props.isOwnMessage ? 'own-dropdown' : 'other-dropdown')}>
                            <a data-toggle="dropdown" onMouseDown={(e) => e.stopPropagation()}>
                                            <img src={_common.GetDefaultIcons('dotsvertical')} alt="Dots" />
                            </a>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a className="dropdown-item" href="javascript:;"onClick={this.deleteMessage.bind(this, this.props.messageId, MessageDeletionType.SingleDelete)}>
                                    {T.t('r_delete_conversation')}
                                </a>
                            </div>
                        </div>
                </div>
            </div>
        );
    }
}
